var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import axios from 'axios';
import { injectable } from 'inversify';
var SettingsService = /** @class */ (function () {
    function SettingsService() {
        this.userSettingsEndpoint = '/api/v1/user-settings';
        this.platformSettingsEndpoint = '/api/v1/platform-settings';
    }
    SettingsService.prototype.toggleUserSettings = function (key, value) {
        var _a;
        return axios.patch("" + this.userSettingsEndpoint, {
            settings: (_a = {},
                _a[key] = value,
                _a),
        });
    };
    SettingsService.prototype.togglePlatformSettings = function (platformId, key, value) {
        var _a;
        return axios.patch("" + this.platformSettingsEndpoint, {
            platform_id: platformId,
            settings: (_a = {},
                _a[key] = value,
                _a),
        });
    };
    SettingsService = __decorate([
        injectable()
    ], SettingsService);
    return SettingsService;
}());
export { SettingsService };
